import { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { CiShare1 } from "react-icons/ci";
import { FaEllipsisVertical } from "react-icons/fa6";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import AdminDeleteModal from "../../../components/CommonComponents/AdminDeleteModal";
import { toast } from "react-toastify";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
import NoRecordTable from "../../../components/CommonComponents/NoRecordTable";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { getItemToken } from "../../../Utils/localStorageUtils";
import { IconDeleteFigma, IconEditFigma } from "../../../Assets/MyIcons";
import { connect } from "react-redux";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import { findUploadName } from "../../../components/CommonMethod/CommonMethods";

function ManageSeries({ siteTheme }) {
  const { deleteImageFile } = useMyContext()
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [apiData, setApiData] = useState([]);
  const [showOverlay, setShowOverlay] = useState(false);
  const [loading, setLoading] = useState(true)
  const [modalClose, setModalClose] = useState(false)
  const [selectAllData, setSelectAllData] = useState(false);
  const [itemDelete, setItemDelete] = useState([]);
  const [languageCode, setLanguageCode] = useState('');
  const userRole = localStorage.getItem("role");
  const baseURL = process.env.REACT_APP_Baseurl
  const frontendBaseURL = `${process.env.REACT_APP_Baseurl_Frontend}`
  const listApi = `${baseURL}/admin/series/category/index`
  const orderApi = `${baseURL}/admin/series/category/order`
  const multiDeleteApi = `${baseURL}/admin/series/category/multi-delete`
  const languageApi = `${baseURL}/admin/User-Translate-Language`
  const headers = getItemToken('access_token');

  const [openParents, setOpenParents] = useState({});

  const toggleSubCategory = (id) => {
    setOpenParents(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const SubCategoryItem = ({ category, depth = 1 }) => {
    const indentStyle = { paddingLeft: `${depth * 30}px` };

    return (
      <>
        <li
          key={category.id}
          className="theme-bg-color theme-text-color w-100 theme-border-bottom-secondary px-3"
          style={indentStyle}
        >
          <div className="row m-0 p-0 align-items-center">
            {userRole == 1 && (
              <div className="rowCheckboxDrag category-order-title">
                <input
                  type="checkbox"
                  checked={itemDelete.includes(category.id)}
                  onChange={() => handleSingleFile(category.id)}
                />
              </div>
            )}

            <div className="col-lg-4 col-md-4 col-sm-4 col-4 category-order-title">
              <div className="d-flex justify-content-between align-items-center">
                <img src={category.image} className="profile" alt="" />

                <div className="rightVideoTitle">
                  <Link
                    className="theme-text-color table-heading d-flex align-items-center"
                    target="_blank"
                    to={
                      siteTheme?.translate_checkout === 1
                        ? `${frontendBaseURL}/${languageCode}/series-genre/${category.slug}`
                        : `${frontendBaseURL}/series-genre/${category.slug}`
                    }
                  >
                    <span title={category.slug}>
                      {category.name?.slice(0, 15)}...
                    </span>
                    <CiShare1 style={{ width: 15, height: 15, marginLeft: 6 }} />
                  </Link>

                  <span className="dateText table-subheading">
                    {category.upload_on}
                  </span>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-3 col-sm-3 col-3 category-order-title">
              <div className=" theme-text-color">{findUploadName(category.uploaded_by)} </div>
            </div>

            {userRole == 1 && (
              <div className="col-lg-2 col-md-2 col-sm-2 col-2 category-order-title">
                <div className="editdropdown">
                  <span className="editdropdown-button">
                    <FaEllipsisVertical className="theme-text-color" />
                  </span>
                  <div className="editdropdown-menu theme-bg-color">
                    <Link to={`/edit-series-category/${category.id}`} className="theme-text-color theme-bg-color">
                      <IconEditFigma styled={{ width: "20px", height: "20px" }} /><MessageBox text="Edit" classname='ms-2 theme-text-color' />
                    </Link>
                    <div onClick={() => handleSingleDelete(category.id)} className="commonActionPadding theme-bg-color">
                      <IconDeleteFigma styled={{ width: "20px", height: "20px" }} /><MessageBox text="Delete" classname='ms-2 theme-text-color' />
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="col-lg-1 col-md-1 col-sm-1 col-1 category-order-title">
              {category.sub_categories?.length > 0 && (
                <span className="cursor-pointer flex items-center justify-center p-2" onClick={() => toggleSubCategory(category.id)}>
                   <FaChevronDown />
                </span>
              )}
            </div>
          </div>
        </li>

        {openParents[category.id] && category.sub_categories?.length > 0 && (
          <ul className="m-0 p-0 list-unstyled">
            {category.sub_categories.map((subCat) => (
              <SubCategoryItem key={subCat.id} category={subCat} depth={depth + 1} />
            ))}
          </ul>
        )}
      </>
    );
  };

  useEffect(() => {
    const fetchLanguageCode = async () => {
      try {
        const { data } = await axios.get(languageApi, { headers });
        if (data?.status) {
          const language = data?.Language_Code || 'en'; // fallback to 'en' or another default if needed
          setLanguageCode(language);
        } else {
          console.warn('Unexpected API response format:', data);
        }
      } catch (error) {
        const errorMsg = error?.response?.data?.message || error.message || 'Unknown error';
        console.error('Error fetching language code:', errorMsg);
      }
    };
    fetchLanguageCode();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(listApi, { headers: headers })
      const result = response?.data?.data;
      if (response?.data?.status) {
        setLoading(false)
        setApiData(result)
      }
      else {
        setLoading(false)
        console.error("series genre fetch error")
      }
    }
    catch (error) {
      setLoading(false)
      const errMessage = error?.response?.data?.message
      console.error(errMessage)
    }
  }
  const handleDeleteImage = async () => {
    await deleteImageFile(itemDelete, "SeriesGenre");
  }

  const handleDelete = async () => {
    setShowOverlay(true);
    await handleDeleteImage();
    handleCloseModal()
    try {
      const response = await axios.delete(multiDeleteApi, {
        headers: headers,
        data: { id: [...itemDelete] },
      });

      const result = response?.data;
      if (result?.status) {
        toast.success(result?.message)
        setWithOutRefresh(!withOutRefresh)
        setShowOverlay(false);
        setSelectAllData(false)
      }
      else {
        toast.error(result?.message)
        setShowOverlay(false);
      }
    }
    catch (err) {
      const errMessage = err?.response?.data?.message
      toast.error(errMessage)
      console.log(err)
    }
  }

  const saveShuffleOrder = async (updatedItems) => {
    setShowOverlay(true);

    if (!updatedItems || updatedItems?.length === 0) {
      toast.error("Menu items are empty");
      return;
    }
    else {
      const positions = updatedItems?.map((menuItem) => menuItem?.id);
      const ids = updatedItems?.map((_, index) => index + 1);
      const requestData = {
        id: positions,
        position: ids,
      };
      try {
        const response = await axios.post(orderApi, requestData, { headers: headers });
        const result = response?.data;
        if (result?.status) {
          toast.success("Order Changed Successssfully");
          setWithOutRefresh(!withOutRefresh)
          setShowOverlay(false);
        }
        else {
          setShowOverlay(false)
          toast.error(result?.message)
        }
      } catch (err) {
        setShowOverlay(false)
        console.error(err);
        var errorMessage = err?.response?.data?.message;
        toast.error(errorMessage)
      }
    }
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const reorderedItems = Array.from(apiData);
    const [movedItem] = reorderedItems?.splice(result.source.index, 1);
    reorderedItems?.splice(result.destination.index, 0, movedItem);
    setApiData(reorderedItems);
    saveShuffleOrder(reorderedItems);
  };

  const handleSelectAllData = () => {
    setSelectAllData(!selectAllData);
    setItemDelete(selectAllData ? [] : apiData?.map((item) => item?.id));
  };

  const handleSingleFile = (itemId) => {
    if (itemDelete?.includes(itemId)) {
      setItemDelete(
        itemDelete?.filter((id) => id !== itemId)
      );
    } else {
      setItemDelete([...itemDelete, itemId]);
    }
  };

  const handleSingleDelete = (id) => {
    setItemDelete([id]);
    setModalClose(true);
    setSelectAllData(false);
  };

  const handleCloseModal = () => {
    setModalClose(!modalClose)
    setItemDelete([]);
  }
  const handleOpenDeleteModal = async () => {
    setModalClose(!modalClose)
  }

  useEffect(() => {
    fetchData()
  }, [withOutRefresh])


  return (
    <div className="pb-5">
      {showOverlay && <Response_Processing></Response_Processing>}
      {modalClose && <AdminDeleteModal modelClose={modalClose} deleteClose={handleCloseModal} deleteAction={handleDelete} buttonText={itemDelete?.length} />}
      <AdminNavbar heading="All Series Genres" totalDataLength={apiData?.length} deleteCount={itemDelete?.length} deleteMethod={handleOpenDeleteModal} {...(userRole == 1 && { navigation: "/add-series-category", navText: "Add Categories" })} />
      <div className="bootstrapTable theme-bg-color p-3 rounded-2">
        <div className="">
          <div className="row m-0 theme-border-bottom-secondary pb-3">
            {userRole == 1 && (<div className="rowCheckboxDrag"> <label><input type="checkbox" checked={selectAllData} onChange={handleSelectAllData} /> </label></div>)}
            <div className="col-lg-4 col-md-4 col-sm-4 col-4 px-5"> <label className="theme-text-color fw-bold fs-6"> Genres </label> </div>
            <div className="col-lg-3 col-md-3 col-sm-3 col-3 "><label className="theme-text-color fw-bold fs-6">Uploaded by</label></div>
            {userRole == 1 && (<div className="col-lg-2 col-md-2 col-sm-2 col-2"><label className="theme-text-color fw-bold fs-6"> Actions </label> </div>)}
            <div className="col-lg-1 col-md-1 col-sm-1 col-1"></div>
          </div>
        </div>
      </div>
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="menu-items" className="theme-bg-color" >
          {(provided) => (
            <ul  {...provided.droppableProps} ref={provided.innerRef} className="pb-5 px-0 theme-bg-color m-0 p-0 list-unstyled">
              {loading ? <NoRecordTable result={apiData?.length} loader={true} /> :
                apiData?.map((item, index) => (
                  <Draggable key={item?.id.toString()} draggableId={item?.id.toString()} index={index} >
                    {(provided) => (
                      <div ref={provided.innerRef} {...provided.draggableProps}>
                        <li {...(userRole == 1 ? provided.dragHandleProps : {})} className={` theme-bg-color theme-text-color   ${item.order} index ${index + 1} w-100 theme-border-bottom-secondary px-3`} >
                          <div className="row m-0 p-0 align-items-center">
                            {userRole == 1 && (
                              <div className="rowCheckboxDrag category-order-title">
                                <input
                                  type="checkbox"
                                  checked={itemDelete.includes(item.id)}
                                  onChange={() => handleSingleFile(item.id)}
                                />
                              </div>
                            )}
                            <div className="col-lg-4 col-md-4 col-sm-4 col-4  category-order-title">
                              <div className="d-flex justify-content-between align-items-center ">
                                <img src={item?.image} className="profile" alt="image_all" />
                                <div className="rightVideoTitle">
                                  <Link className="theme-text-color table-heading d-flex align-items-center" target="_blank"
                                    to={siteTheme?.translate_checkout === 1
                                      ? `${frontendBaseURL}/${languageCode}/series-genre/${item?.slug}`
                                      : `${frontendBaseURL}/series-genre/${item?.slug}`} >
                                    <span title={item?.slug}> {`${item?.name?.slice(0, 15)}...`}   </span>
                                    <CiShare1 style={{ width: "15px", height: "15px", strokeWidth: "1px", marginLeft: "6px" }} />
                                  </Link>
                                  <span className="dateText table-subheading "> {item?.upload_on}</span>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-3 col-3  category-order-title">
                              <div className=" theme-text-color">{findUploadName(item.uploaded_by)} </div>
                            </div>
                            {userRole == 1 && (
                              <div className="col-lg-2 col-md-2 col-sm-2 col-2 category-order-title">
                                <div className="editdropdown">
                                  <span className="editdropdown-button">
                                    <FaEllipsisVertical className="theme-text-color" />
                                  </span>
                                  <div className="editdropdown-menu theme-bg-color">
                                    <Link to={`/edit-series-category/${item?.id}`} className="theme-text-color theme-bg-color">
                                      <IconEditFigma styled={{ width: "20px", height: "20px" }} /><MessageBox text="Edit" classname='ms-2 theme-text-color' />
                                    </Link>
                                    <div onClick={() => handleSingleDelete(item?.id)} className="commonActionPadding theme-bg-color">
                                      <IconDeleteFigma styled={{ width: "20px", height: "20px" }} /><MessageBox text="Delete" classname='ms-2 theme-text-color' />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            <div className="col-lg-1 col-md-1 col-sm-1 col-1 category-order-title">
                              {item.sub_categories?.length > 0 && (
                                <span className="cursor-pointer flex items-center justify-center p-2" onClick={() => toggleSubCategory(item.id)}>
                                  <FaChevronDown />
                                </span>
                              )}
                            </div>

                          </div>
                        </li>

                        {openParents[item.id] && item.sub_categories?.length > 0 && (
                          <ul className="m-0 p-0 list-unstyled">
                            {item.sub_categories.map((sub) => (
                              <SubCategoryItem key={sub.id} category={sub} depth={1} />
                            ))}
                          </ul>
                        )}

                      </div>
                    )}
                  </Draggable>
                ))}

            </ul>
          )}
        </Droppable>
      </DragDropContext>

    </div>
  );
}

const mapStateToProps = (state) => ({
  siteTheme: state.siteTheme.siteTheme
});

export default connect(mapStateToProps)(ManageSeries)